import { RootErrorFallback } from '@eventbrite/eds-structure';
import { SiteStructure } from '@eventbrite/site-structure';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useEnvContext } from '../context/env';
import { FooterLinks } from '../types';

interface ThingsToDoBasePageProps {
    footerLinks: FooterLinks;
}

export const ThingsToDoBasePage: React.FunctionComponent<
    ThingsToDoBasePageProps
> = (props) => {
    const envContext = useEnvContext();

    return (
        <SiteStructure
            env={envContext.env}
            request={envContext.request}
            user={envContext.user}
            footerLinks={props.footerLinks}
            fullScreenMain={true}
        >
            <Sentry.ErrorBoundary
                fallback={<RootErrorFallback />}
                onError={(error) => {
                    if (process.env.NODE_ENV !== 'production') {
                        throw error;
                    }
                }}
            >
                {props.children}
            </Sentry.ErrorBoundary>
        </SiteStructure>
    );
};
